import { Center, useMultiStyleConfig } from '@chakra-ui/react';
import React from 'react';

import { Text } from '../Text';

interface StatisticProps {
  icon?: React.ReactElement;
  stat: string | React.ReactElement;
  context: string | React.ReactElement;
}

const Statistic: React.FC<StatisticProps> = ({ icon, stat, context }) => {
  const Styles = useMultiStyleConfig('Statistic', { hasIcon: !!icon });
  return (
    <Center sx={Styles.container}>
      {icon}
      <Text sx={Styles.stat}>{stat}</Text>
      <Text sx={Styles.context}>{context}</Text>
    </Center>
  );
};

export default Statistic;
